import React from 'react';
import ReactGA from 'react-ga';
import GIECard from '../../components/GIECard/GieCard';
import LoginController from '../../controller/login.controller';
import GIELink from "../../components/GIELink/GIELink";
import GIESvgIcon from "../../components/GIEIcon/GIESvgIcon";
import enveloppeIcon from "../../assets/icon/envelope.svg";

export default class VerifyEMail extends React.Component<any, any> {
  loginController: LoginController = new LoginController();

  constructor(props) {
    super(props);
    this.state = {
      verify: false
    }
  }

  componentDidMount() {
    ReactGA.pageview(window.location.pathname + window.location.search);

    const token = window.location.href.split('/')[window.location.href.split('/').length - 1]
    const noContract = window.location.href.split('/')[window.location.href.split('/').length - 2]
    const request = {
      noContract,
      token
    }
    this.loginController.verifyMail(request).then(data => {
      this.setState({verify: true})
    }).catch(err => {
      console.log(err)
    })
  }

  render() {
    return (
      <div className="content">
        <div className="blue-bg-container">
          <div className="m-auto">
            <GIECard width="500px" height="100%">
              <div className="p-4">
                <div>
                  <h2 className="text-center">Votre compte est activé</h2>
                </div>
                {this.state.verify === false ? (
                  <div className="text-center my-5">
                    <span>Votre email n'est pas vérifié</span>
                  </div>
                ) : (
                  <div>
                    <div className="text-center my-5">
                      <GIESvgIcon big icon={enveloppeIcon}/>
                    </div>
                    <div className="text-center">
                      <GIELink href="/admin/login" arrowAfter>Se Connecter</GIELink>
                    </div>
                  </div>
                )}
              </div>
            </GIECard>
          </div>
        </div>
      </div>
    )
  }
}
